import {Component, Element, Host, h, Prop, Watch, State} from '@stencil/core'
import {LinkClass, LinkSizes, LinkSizesType} from './constants'
import { govHost } from '../../helpers/Dom/template'
import { GovHost } from '../../helpers/Dom/template.types'
import {validateProp} from "../../helpers/Validate/props";
import {Attributes} from "../../helpers/Dom/attribute";
import {inheritAriaAttributes} from "../../helpers/Accessibility/accessibility";

@Component({
	tag: 'gov-link',
})
export class GovLink {
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	@Element() host: HTMLGovLinkElement
	/**
	 * Element size.
	 */
	@Prop() readonly size?: LinkSizesType = 'm'
	/**
	 * Element size.
	 */
	@Prop() readonly external?: boolean = false
	/**
	 * Cutting text to one line
	 */
	@Prop() readonly truncate?: boolean = false
	/**
	 * Same as original parameter
	 * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-href
	 */
	@Prop() readonly href: string
	/**
	 * Same as original parameter
	 * @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target
	 */
	@Prop() readonly target: string


	@Watch('size')
	validateSize(newValue: string): void {
		validateProp(LinkSizes, newValue, LinkClass.root)
	}

	@State() inheritedAttributes: Attributes = {}

	componentWillLoad(): void {
		this.validateSize(this.size)
		this.inheritedAttributes = inheritAriaAttributes(this.host)
	}

	onAriaAttributeChange(attributeName: string, newValue: string) {
		this.host.removeAttribute(attributeName)
		this.inheritedAttributes = {...this.inheritedAttributes, [attributeName]: newValue};
	}

	render() {
		return (
			<Host class={this.h.classes(LinkClass.root)}
				  size={this.size}
				  href={this.href}
				  external={this.external}
				  truncate={this.truncate}>
				<a class="element"
				   href={this.href}
				   target={this.external ? '_blank' : this.target}
				   rel={this.external ? "noreferrer" : null}
				   {...this.inheritedAttributes}>
					<slot name="icon-start"/>
					<span><slot/></span>
					<slot name="icon-end"/>
					{this.external && <gov-icon name="box-arrow-up-right" type="components" size={this.size} class={LinkClass.external}></gov-icon>}
				</a>
			</Host>
		)
	}
}
